export default __webpack_public_path__ + "static/garden13-min-d0d0c31ce5993d76576748308ef8e7b1.jpg";